module.exports = {
  menuHomeLabel: 'Home',
  menuBenefitsLabel: 'Beneficios',
  menuEarningsLabel: 'Ganancias como consultora',
  menuOurCausesLabel: 'Consultoría de Belleza',
  menuHelpLabel: 'Preguntas Frecuentes',
  homeId: 'home',
  homeHeroSectionId: 'hero',
  homeHeroCTAButtonText: 'Regístrate aquí',
  homeHeroCTAButtonAccessibleLabel: 'Registrarse',
  homeHeroSubtitle:
    '¡Cuando nos encontramos, nos apoyamos y tu vas más lejos! Únete a la Consultoría de Belleza Natura y Avon y transforma tu vida y el mundo.',
  homeHeroTitle: 'Vive la belleza del encuentro',
  homeHeroImageAlt: 'Mujeres abrazando sonriendo.',
  homePageTitle: 'Quiero ser Consultora',
  benefitsSectionId: 'beneficios',
  benefitsHeadingTitle: 'Beneficios',
  benefitsHeadingSubtitle:
    'Nuestra Consultoría de Belleza es apasionada por las relaciones humanas y los cosméticos. Mira cuáles son las ventajas para ti:',
  benefitHealthTitle: 'Productos de Calidad',
  benefitHealthText:
    'Tenemos los productos más deseados del mercado peruano. La calidad e innovación de nuestros productos hacen fácil su venta, y sobretodo son seguros para ti y para el medioambiente.',
  benefitEducationTitle: 'Entrenamiento',
  benefitEducationText:
    'Tendrás capacitaciones a tu disposición para tu desarrollo personal y profesional, con herramientas que te permitirán conocer nuestros productos y cómo potencializar tu negocio.',
  benefitOnlineSellsTitle: 'Produtos apasionantes',
  benefitOnlineSellsText:
    'Ofreces una Consultoría de Belleza llena de innovación y los mejores productos de Natura y Avon, además de las opciones de Casa y Estilo, para deleitar a tus clientes en cualquier momento.',
  benefitBonusTitle: 'Campañas de ventas',
  benefitBonusText:
    'Participa en nuestras campañas de ventas y gana increíbles premios y viajes de incentivos. ',
  benefitRecognitionTitle: 'Eventos y Reconocimientos',
  benefitRecognitionText:
    'Reconocemos tu valiosa participación en nuestra red de relaciones, a través de eventos exclusivos e increíbles viajes.',
  benefitRegisterButtonText: 'Regístrate aquí',
  ctaButtonLinkDesktop: '/co/auto',
  ctaButtonLinkMobile: '/co/auto',
  earningsSectionId: 'ganancias-como-consultora',
  earningsHeadingTitle: 'Ganancias como Consultora',
  earningsHeadingSubtitle:
    'Descubre cuanto podrías ganar con la venta de este Kit de productos de Natura y Avon en Venta por revista y en Venta online.',
  earningsProduct1Title: 'Kaiak clásico femenina: $ 139.300',
  earningsProduct1Description: 'Una deslumbrante explosión cítrica de bergamota y naranja, con notas femeninas de jazmín',
  earningsProduct2Title: 'Ekos Castaña: $ 45.800',
  earningsProduct2Description: '100% vegano y conserva la Amazonia brasileña',
  earningsProduct3Title: 'Far Away: $ 66.900',
  earningsProduct3Description:
    'Un perfume floral oriental para proyectar una faceta glamourosa',
  earningsProduct4Title: '5 in One Lash Genius Mascara: $ 22.900',
  earningsProduct4Description:
    'Mascara Multibeneficios para Pestañas',
  earningsCalculatorChartResultText: 'Tu cliente compra este kit por:',
  earningsCalculatorChartResultDescription:
    'Tu ganancia {salesType, select, true {en Ventas por revista,} false {en Venta Online,}} según tu nivel es:',
  earningsChartLevelSeed: 'Semilla',
  earningsChartLevelBronze: 'Bronce',
  earningsChartLevelSilver: 'Plata',
  earningsChartLevelGold: 'Oro',
  earningsChartLevelDiamond: 'Diamante',
  onlineSalesButtonText: 'Venta Online',
  regularSalesButtonText: 'Ventas por revista',
  ourCausesSectionId: 'nuestras-causas',
  ourCausesHeadingTitle: 'Consultoría de Belleza',
  ourCausesHeadingSubtitle: 'Nuestra Consultoría cree que el poder de venta por relación es el secreto del éxito. Juntas, transformamos el mundo, y con Natura y Avon, tú puedes lograr mucho más:',
  ourCausesAmazonTitle: 'Amazonia Viva',
  ourCausesAmazonText:
    '¡Incluye los productos Natura y Avon en un solo pedido, recíbelos todos en la misma caja y paga una única factura! Simple, ¿no?<br/> Con pedidos, pagos e incluso entrenamientos organizados en un solo lugar, tendrás todo el apoyo para dar lo mejor de ti y brillar en el negocio.',
  ourCausesRecyclingTitle: 'Más belleza, menos residuos',
  ourCausesRecyclingText:
    'Puedes sumar puntos con productos de ambas marcas para el Camino de Crecimiento, lo que acelera tu desarrollo como Consultora de Belleza.<br> Son más las posibilidades de ganancias, independencia para tu rutina, aprendizajes y ventajas, ¡todo para que puedas expandir tus ventas y obtener muchos más beneficios!',
  phone: '01-311-0031',
  helpSectionId: 'preguntas-frecuentes',
  helpHeadingTitle: 'Preguntas Frecuentes',
  footerTitle: 'Vea también',
  footerCallCenterLabel: 'SAC',
  footerCopyRightLabel: 'Todos los derechos reservados.'
}
